const base = "https://beauhobbawebsitemedia.s3.ap-southeast-2.amazonaws.com/";

export const image_library = {
  inspector: `${base}Inspector/inspector.png`,
  inspector_2: `${base}Inspector/inspector_2.png`,
  inspector_3: `${base}Inspector/inspector_3.png`,

  roost1: `${base}Roost/roost1.png`,
  roost2: `${base}Roost/roost2.png`,
  roost3: `${base}Roost/roost3.png`,
  roost4: `${base}Roost/roost4.png`,
  roost5: `${base}Roost/roost5.png`,
  roost6: `${base}Roost/roost6.png`,
  roost_game: `${base}Roost/roost_game.png`,
  roost_box_gif: `${base}Roost/box.gif`,

  deepracer_title: `${base}Deepracer/deepracer_title.png`,
  deepracer_1: `${base}Deepracer/deepracer_1.png`,
  deepracer_2: `${base}Deepracer/deepracer_2.png`,

  Robotatouille1: `${base}Robotatouille/Robotatouille1.png`,
  Robotatouille2: `${base}Robotatouille/Robotatouille2.png`,
  Robotatouille3: `${base}Robotatouille/Robotatouille3.png`,
  Robotatouille4: `${base}Robotatouille/Robotatouille4.png`,
  Robotatouille5:  `${base}Robotatouille/Robotatouille5.jpg`,
};

export const video_library = {
  inspector_demo: `${base}Inspector/inspector_demo_compressed.mp4`,
  inspector_tracking: `${base}Inspector/inspector_tracking_compressed.mp4`,

  deepracer_video: `${base}Deepracer/deepracer_video.mp4`,

};

export const pdf_library = {
  // Resume is hidden for now - no public download link.
  // resume: `${base}Resume/resume_2025.pdf`,
  herbicide: `${base}HerbicideMapping/herbicidemapping.pdf`,
  robotatouille: `${base}Robotatouille/Robotatouille.pdf`,
};
